<template>
    <div>
        <!-- Start Footer -->
        <footer class="section footer position-relative">
            <div class="container">
                <div class="row">
                    <div class="col-lg-3 col-sm-3 mt-sm-0 mt-4">
                        <ul class="list-unstyled mb-0">
                            <li>
                                <img src="assets/images/general/anchor_logo.png" class="img-fluid logo-light" height="100" width="200" alt="">
                            </li>
                            <li class="mt-4">
                                <h5 class="text-white">ALWAYS ADVANCING</h5>
                                
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-4 col-sm-5 link-border-right mt-sm-0 mt-4">
                        <h5 class="footer-title text-white">Links</h5>
                        <div class="row">
                            <div class="col-lg-4 col-sm-6">
                                <ul class="footer_menu_list list-unstyled mb-0">
                                    <li>
                                        <a href="https://www.anchorgroupcorp.com/" class="text-white f-14 d-inline-block transition">Home</a>
                                    </li>
                                    <li>
                                        <a href="https://www.anchorgroupcorp.com/who-we-are/" class="text-white f-14 d-inline-block transition">About Us</a>
                                    </li>
                                    <li>
                                        <a href="https://www.anchorgroupcorp.com/serviceoverview/" class="text-white f-14 d-inline-block transition">Services</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-lg-4 col-sm-6">
                                <ul class="footer_menu_list list-unstyled mb-0">
                                    <li>
                                        <a href="https://www.anchorgroupcorp.com/mission-vision/" class="text-white f-14 d-inline-block transition">Mission & vision</a>
                                    </li>
                                    <li>
                                        <a href="https://www.anchorgroupcorp.com/partners/" class="text-white f-14 d-inline-block transition">Partners</a>
                                    </li>
                                    <li>
                                        <a href="#contactForm" class="text-white f-14 d-inline-block transition">Contact</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-5 col-sm-4 my-sm-0 mt-4">
                        <h5 class="footer-title text-white text-sm-right text-left">Follow Us</h5>
                        <div class="footer_menu_list list-unstyled mb-0 text-sm-right text-left">
                            <a href="https://www.facebook.com/AnchorGroupCorp/" class="transition icn-block d-inline-block transition">
                                <i class="icon pr-2 mdi mdi-facebook text-white f-34 d-inline-block"></i>
                            </a>
                            <a href="https://www.twitter.com/anchorgroupcorp" class="transition icn-block d-inline-block transition">
                                <i class="icon pr-2 mdi mdi-twitter text-white  f-34 d-inline-block"></i>
                            </a>
                            <a href="https://www.instagram.com/anchorgroupcorp" class="transition icn-block d-inline-block transition">
                                <i class="icon pr-2 mdi mdi-instagram text-white f-34 d-inline-block"></i>
                            </a>
                            <a href="https://www.linkedin.com/company/anchor-strategy-group" class="transition icn-block d-inline-block transition">
                                <i class="icon pr-2 mdi mdi-linkedin text-white f-34 d-inline-block"></i>
                            </a>
                        </div>
                        <div class="pt-4">
                            <p class="mb-0 text-sm-right text-left text-white"> &copy; Copyright 2022 Allrights Reserved- Anchor Group Corp</p>
                        </div>
                    </div>

                </div>
            </div>
        </footer>
        <!-- End Footer -->
        <!-- Back To Top -->
        <a href="#" class="back_top rounded-circle text-center transition"><i class="mdi mdi-monitor-dashboard d-block text-white"></i></a>
    </div>
</template>
<script>
    export default {
        name: "anchor_footer",
        methods: {
        }
    }</script>
